import moment from 'moment'

const formatWeek = (year: string, timeSlot: string) => {
  const weekStart = moment().year(Number(year)).week(Number(timeSlot)).startOf('week')
  const weekEnd = weekStart.clone().endOf('week')

  return `${weekStart.format('D MMM')} - ${weekEnd.format('D MMM')}`
}

export const formatGraphTimeTitle = (year: string, timeSlot: string, slotType: string) => {
  if (slotType === 'weeks') {
    return formatWeek(year, timeSlot)
  }

  if (slotType === 'months') {
    return moment(timeSlot).format('MMM')
  }

  if (slotType === 'years') {
    return year
  }

  return moment(timeSlot).format('D MMM')
}

export const formatYAxisWithLargeNumbers = (value: number, currency: string) => {
  const thresholds = [
    { limit: 1_000_000_000_000, suffix: 'T' }, // Trillions
    { limit: 1_000_000_000, suffix: 'B' }, // Billions
    { limit: 1_000_000, suffix: 'M' }, // Millions
    { limit: 1_000, suffix: 'k' }, // Thousands
  ]

  for (const { limit, suffix } of thresholds) {
    if (value >= limit) {
      const formattedValue =
        value % limit === 0 ? (value / limit).toString() : (value / limit).toFixed(1)
      return `${formattedValue}${suffix} ${currency}`
    }
  }

  return `${value} ${currency}`
}
